import {SESSION_STORAGE_KEYS} from "@js/constants/js-constants.es6.js";

export default class SessionStorageUtils {
  /**
   * Get the sesssion storage value for the provided key, converting the string
   * represenation of null and undefined.
   *
   * @param {*} key the key to pull the session storage value for
   * @return {string} the session storage value as a string, null, or undefined
   */
  static getItem(key) {
    const value = sessionStorage.getItem(key);
    if (value === 'undefined') {
      return undefined;
    }
    if (value === 'null') {
      return null;
    }

    return value;
  }

  /**
   * Set the sesssion storage value for the provided key if it is not undefined
   * or null.
   *
   * @param {*} key the key to set the session storage value for
   * @param {*} value the value to set
   */
  static setItem(key, value) {
    if (value === undefined || value === null) {
      sessionStorage.removeItem(key);
    } else {
      sessionStorage.setItem(key, value);
    }
  }

  static removeItem(key) {
    sessionStorage.removeItem(key);
  }

  static clearAppointmentSpecificSessionStorage() {
    sessionStorage.removeItem(SESSION_STORAGE_KEYS.ACCESSIBILITY_TYPE);
    sessionStorage.removeItem(SESSION_STORAGE_KEYS.APPOINTMENT_LOCATION);
    sessionStorage.removeItem(SESSION_STORAGE_KEYS.APPOINTMENT_NOTES_REQUIRED);
    sessionStorage.removeItem(SESSION_STORAGE_KEYS.APPOINTMENT_TYPE);
    sessionStorage.removeItem(SESSION_STORAGE_KEYS.DURATION_MINS);
    sessionStorage.removeItem(SESSION_STORAGE_KEYS.EPIC_APPOINTMENT_TYPE);
    sessionStorage.removeItem(SESSION_STORAGE_KEYS.EPIC_DEPARTMENT_ID);
    sessionStorage.removeItem(SESSION_STORAGE_KEYS.EPIC_PROVIDER_ID);
    sessionStorage.removeItem(SESSION_STORAGE_KEYS.HAS_REFERRAL);
    sessionStorage.removeItem(SESSION_STORAGE_KEYS.INSURANCE_REQUIREMENT);
    sessionStorage.removeItem(SESSION_STORAGE_KEYS.MNEMONIC);
    sessionStorage.removeItem(SESSION_STORAGE_KEYS.REFERRAL_REQUIREMENT);
    sessionStorage.removeItem(SESSION_STORAGE_KEYS.RESERVATION_KEY);
    sessionStorage.removeItem(SESSION_STORAGE_KEYS.RESERVED_TIME_SLOT);
  }
}
